<template>
<v-btn
  @click='save'
  type='submit'
  :primary='isPrimary'
  :flat='isFlat'
  :success='isSuccess'
  :error='isError'
  :disabled='isDisabled'
  :block='isBlock'
  :color='color'
  :class='classes'
  :loading='request.loading' >
  <v-icon>{{iconText}}</v-icon> {{buttonText}}
</v-btn>
</template>

<script>
export default {
  name: 'VuexButton',
  props: {
    reqId: { type: String },
    text: { type: String },
    color: { type: String, default: 'primary' },
    classes: { type: Array, default: () => { return [] } },
    buttonType: { type: String, default: 'primary' },
    loadingText: { type: String, default: 'loading' },
    successText: { type: String, default: 'success' },
    successIcon: { type: String, default: 'check' },
    errorText: { type: String, default: 'Something went wrong' },
    errorIcon: { type: String, default: 'error' },
    isDisabled: { type: Boolean, default: false },
    isBlock: { type: Boolean, default: false },
    isFlat: { type: Boolean, default: false },
    initialButtonType: { type: String, default: 'primary' },
    icon: { type: String, default: '' },
    successWaitTime: { type: Number, default: 2500 }
  },
  data () {
    return {
      isSuccess: false,
      isError: false,
      iconText: this.icon,
      buttonText: this.text,
      originalIcon: this.icon,
      originalText: this.text,
      state: 'neutral',
      loading: false
    }
  },
  mounted () {
    if (this.initialButtonType === 'error') {
      this.isError = true
    }
    if (this.initialButtonType === 'success') {
      this.isSuccess = true
    }
  },
  computed: {
    request () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    requestStatus () {
      return this.request.status
    },
    isPrimary () { return this.buttonType === 'primary' }
    // isFlat () { return this.buttonType === 'flat' }
  },
  watch: {
    requestStatus () {
      let successResponses = [200, 201]
      if (successResponses.indexOf(this.requestStatus) !== -1) {
        this.buttonText = this.successText
        this.iconText = this.successIcon
        this.isSuccess = true
        setTimeout(this.backToOriginal, this.successWaitTime)
      }
      if (this.requestStatus === 400) {
        this.buttonText = this.errorText
        this.iconText = this.errorIcon
        this.isError = true
        setTimeout(this.backToOriginal, this.successWaitTime)
      }
    }
  },
  methods: {
    save () {
      this.$emit('save')
    },
    backToOriginal () {
      this.buttonText = this.originalText
      this.iconText = this.originalIcon
      this.isSuccess = false
      this.isError = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// VuexBtn.vue?28ab3759